import React, { Fragment, Suspense } from "react";
import { Helmet } from "react-helmet";
import Preloader from "../Components/Common/Preloader";
import { metaTag } from "../Library/commomLib";
const ButtonsComponent = React.lazy(() => import("../Components/RootComponents/ButtonsComponent"));
const ButtonsPage = () => {
  return (
    <Fragment>
      <Suspense fallback={<Preloader />}>
        <Helmet>
          <title>{metaTag}</title>
          <meta name={metaTag} content={metaTag} />
        </Helmet>
        <ButtonsComponent />
      </Suspense>
    </Fragment>
  );
};

export default ButtonsPage;
